import { FC } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

interface Props {
  children: React.ReactNode;
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY as string);

export const StripeElementsProvider: FC<Props> = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
